const UserIcon: React.FC = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.9815 16.7248C14.6121 14.9175 12.4424 13.75 10 13.75C7.55761 13.75 5.38789 14.9175 4.01846 16.7248M15.9815 16.7248C17.8335 15.0763 19 12.6744 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 12.6744 2.1665 15.0763 4.01846 16.7248M15.9815 16.7248C14.3915 18.1401 12.2962 19 10 19C7.70383 19 5.60851 18.1401 4.01846 16.7248M13 7.75C13 9.40685 11.6569 10.75 10 10.75C8.34315 10.75 7 9.40685 7 7.75C7 6.09315 8.34315 4.75 10 4.75C11.6569 4.75 13 6.09315 13 7.75Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

UserIcon.displayName = 'UserIcon'

export default UserIcon
